<template>
  <div :class="classes()">
    <AuthScreen>
      <RegisterForm slot="formBox" />
    </AuthScreen>
  </div>
</template>

<script>
import RegisterForm from '@/components/Forms/RegisterForm';
import AuthScreen from '@/components/AuthScreen';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { mapFieldsAuth } from '@/store/mapFields';

export default {
  name: 'SignUp',
  props: {},
  components: {
    RegisterForm,
    AuthScreen,
  },
  computed: {
    ...mapFieldsAuth(['isAuthenticated']),
  },
  watch: {
    '$store.state.auth.isAuthenticated': function () {
      this.redirectToDashboard();
    },
  },
  data() {
    return {
      el: 'v-signUp',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  title() {
    return 'Registrieren';
  },
  created() {
    if (this.isAuthenticated) {
      this.$router.push(ROUTE_DASHBOARD);
    }
  },
  methods: {
    redirectToDashboard() {
      if (this.isAuthenticated) {
        this.$router.push(ROUTE_DASHBOARD);
      }
    },
  },
};
</script>
